export const isReselectingEditedCabinet = (
    cabinetIdParam: string | null | undefined,
    jobCabinetId: unknown
): boolean => {
    if (
        !cabinetIdParam ||
        jobCabinetId === undefined ||
        jobCabinetId === null
    ) {
        return false;
    }
    return cabinetIdParam === String(jobCabinetId);
};
